import React from "react";
import FormsButton from "../../components/FormSection/FormsButton";
import classes from "../../components/FormSection/FormsButton.module.css";

const linkItems = [
  {
    name: "Change of Address Form",
    href: "/borrower/change-of-address",
  },
  {
    name: "One-Time ACH Payment",
    href: "/borrower/one-time-ach-debit",
  },
  { name: "Recurring ACH Payment", href: "/borrower/ach-direct-debit" },
  { name: "Demand Request Form", href: "/borrower/demand-request-form" },
  { name: "IRS - W9 Form", href: "/borrower/IRS-W9-form" },
  {
    name: "Signature Authorization",
    href: "/borrower/signature-authorization",
  },
  //   {
  //     name: "Statement of Information",
  //     href: "/borrower/statement-of-information",
  //   },
  { name: "Draw Request Form", href: "/borrower/draw-request-form" },
  { name: "Borrower 3rd Party Auth.", href: "/borrower/3rd-party-auth" },
  { name: "Financial Assistance", href: "/borrower/financial-assistance" },
];

const BorrowerForms = () => {
  return (
    <section
      className="text-start container-fluid my-4 px-0 rounded"
      style={{ background: "#eeeeee", minHeight: "100vh" }}
    >
      <div className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <div style={{ backgroundColor: "#FF8057", padding: "36px 0" }}>
            <h3
              style={{
                fontSize: "55px",
                color: "#fff",
                textAlign: "center",
                padding: "17px 0",
              }}
            >
              Borrower Forms
            </h3>
          </div>
          <FormsButton
            heading="Loan servicing forms"
            options={linkItems}
            classname={classes.background}
          />
        </div>
      </div>
    </section>
  );
};

export default BorrowerForms;
